module.exports = __webpack_public_path__ + "static/media/fastCarcas.af36d4ab.jpg";